document.addEventListener('DOMContentLoaded', (event) => {
    const disableInputBoxOneTree = () => {
        const boxOneTree = document.querySelector("#updates_41088361463921");
        const divOneTree = document.querySelector(".cart-flyout-item .one-tree-planted");
        const divOneTreeCart = document.querySelector(".cart-body .product-one-tree-planted");

        if (boxOneTree && (divOneTree || divOneTreeCart)) {
            boxOneTree.setAttribute("disabled", "disabled");

            const spansToHide = divOneTreeCart?.querySelectorAll("span.down, span.up, div.cart-remove-btn");
            spansToHide?.forEach(span => {
                span.style.display = "none";
            });
        }
    };
    setTimeout(disableInputBoxOneTree, 1000);

    const cartContainer = document.querySelector('#CartFlyout');
    if (cartContainer) {
        const observer = new MutationObserver(disableInputBoxOneTree);
        observer.observe(cartContainer, { childList: true, subtree: true });
    }

    const cartPageContainer = document.querySelector('#cart-page');
    if (cartPageContainer) {
        const observer = new MutationObserver(disableInputBoxOneTree);      
        observer.observe(cartPageContainer, { childList: true, subtree: true });
    }

    window.addEventListener('load', async () => {
        const chatElement = await document.querySelector('#ShopifyChat')
        if (chatElement) {
            chatElement.style.zIndex = '1';
        }
    });
});